export const APP_NAME = 'MemoriaHub';
